import React from 'react';
import { exclametry_red_dark, eye, eyeoff } from '../../../../assets/images';

const Login = ({
  show_password = false,
  errors,
  username,
  password,
  setfields,
  handleLogin,
  toggleVisiblity,
  history,
}) => {
  const { usernameerr, passworderr } = errors;

  return (
    <div className='mt-12'>
      <h1 className='mb-0 text-gray-900 font-bold text-2xl leading-none'>Log in to data vue</h1>
      <div className='mt-12 text-gray-600 text-xs flex flex-col w-full'>
        <span className='mb-3 text-gray-600 text-sm font-semibold'>Email address</span>
        <input
          id='input_username'
          type='text'
          name='username'
          placeholder='name@company.com'
          value={username}
          onChange={setfields}
          className={
            'text-base caret-blue-600 text-gray-700 leading-4 h-12 placeholder-gray-300  font-semibold pl-4 border border-gray-200 rounded-md w-96 focus:border-gray-400  bg-gray-100 focus:bg-gray-100 focus:ring-0  focus:outline-none ' +
            (!usernameerr ? ' focus:border-gray-400':' border-red-600')
          }
        />
        {usernameerr && (
          <p className='mb-0 mt-2 text-xs font-semibold text-red-600 flex flex-row'>
            <img src={exclametry_red_dark} className='h-3 w-3 mr-1'/>
            {usernameerr}
          </p>
        )}

        <span className='mt-8 mb-3 text-gray-600 text-sm font-semibold'>Password</span>
        <div className='flex items-end'>
          <input
            id='input_password'
            type='password'
            name='password'
            placeholder='*********'
            value={password}
            onChange={setfields}
            className={
              `text-base  caret-blue-600 text-gray-700 placeholder-gray-300 leading-4  font-semibold pl-4 border border-gray-200 focus:border-gray-400 rounded-md w-96 h-12 bg-gray-100 focus:bg-gray-100 focus:ring-0  focus:outline-none ${!password && 'pt-4 tracking-widest'}` +
              (!passworderr ? ' focus:border-gray-400':' border-red-600')
            }
          />
          <img
            src={show_password ? eye : eyeoff}
            className='inline-block h-6 w-6 relative bottom-3 right-10 cursor-pointer'
            onClick={toggleVisiblity}
            alt='eye_icon'
          />
        </div>
        {passworderr && (
          <p className='mb-0 mt-2 font-semibold text-xs mr-24 text-red-600 flex flex-row'>
            <img src={exclametry_red_dark} className='h-3 w-3 mr-1'/>
            {passworderr}
          </p>
        )}
          <p
            onClick={() => history.push('forgot-password')}
            className='mb-0 mt-4 text-gray-400  font-semibold text-sm  w-max cursor-pointer border-white border-b hover:text-blue-600 hover:border-blue-600'
            style={{marginLeft : '272px'}}
          >
            Forgot password?
          </p>
        <button
          onClick={handleLogin}
          className='bg-blue-600 text-white w-96 py-4 rounded-md text-lg mt-12 font-semibold hover:bg-blue-600 focus:outline-none'
        >
          Log in
        </button>
        <p className='mb-0 font-normal text-gray-500 mt-8 text-sm w-96 text-center'>
          By logging in, you will agree with ekincare’s {' '}
          <a
            href='https://www.ekincare.com/about/terms'
            target='_blank'
            rel='noopener noreferrer'
            className='text-blue-500 cursor-pointer hover:text-blue-500 hover:underline'
          >
            Terms and conditions{' '}
          </a>
          and{' '}
          <a
            href='https://www.ekincare.com/about/privacy'
            target='_blank'
            rel='noopener noreferrer'
            className='text-blue-500 cursor-pointer hover:text-blue-500 hover:underline'
          >
            privacy policy{' '}
          </a>
        </p>
        <div className='text-gray-500 ml-36 mt-12'>A product by{' '}
          <a
              href='https://www.ekincare.com'
              target='_blank'
              rel='noopener noreferrer'
              className='text-gray-700 text-xs font-semibold cursor-pointer hover:text-blue-900 hover:underline'
            >
              ekincare{' '}
            </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
